import { ToggleField } from 'components/molecules'
import { FieldArray, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import UpdatePackingSchema from './update-packing-schema'
import DateInputField from 'components/molecules/date-input-field'

const propTypes = {
  onSubmitForm: PropTypes.func.isRequired
}

const productAuthenticationSummary = (product) => {
  const status = product?.authentication_summary_label || product?.authentication_status_label || 'Not Checked'
  const link = product?.authentication_certificate_url || product?.authentication_certificate_link

  return { status, link }
}

/**
  * @param {Date} pickup_at - Estimated pick up date of the package
  * @param {Boolean} invoice_done - whether invoice is included in the packaging
  * @param {Boolean} polaroid_done - whether polaroid is included in the packaging
  * @param {Boolean} love_letter_done - whether loveletter is included in the packaging
  * @param {Boolean} ready_to_ship - whether the whole Deal is ready to be shipped
  * @param {Array<Object>} cart_item_updates - id of CartItem and _done fields included
 */
const UpdatePackingForm = ({ deal, onSubmitForm }) => {
  const initialValues = {
    pickup_at: deal.pickup_at,
    invoice_done: deal.invoice_done || false,
    polaroid_done: deal.polaroid_done || false,
    love_letter_done: deal.love_letter_done || false,
    ready_to_ship: deal.ready_to_ship || false,
    cart_item_updates: deal.cart.cart_items.map(item => ({
      id: item.id,
      authenticity_check_done: item.authenticity_check_done,
      note_done: item.note_done,
    })),
  };

  return (
    <Formik
      initialValues={ initialValues }
      validationSchema={ UpdatePackingSchema }
      onSubmit={ (values, formikBag) => onSubmitForm(values, formikBag) }
    >
      {
        (formikBag) => (
          <Form onSubmit={(e) => e.preventDefault()}>
            <DateInputField
              label='Pickup Date'
              name='pickup_at'
              dateFormat="dd/MM/yyyy"
              required={ false }
              formText='format: dd/mm/yy'
            />

            <ToggleField
              type="checkbox"
              name="invoice_done"
              label="Invoice Done"
              required={deal.include_invoice}
            />

            <ToggleField
              type="checkbox"
              name="polaroid_done"
              label="Polaroid Done"
              required={deal.include_polaroid}
            />

            <ToggleField
              type="checkbox"
              name="love_letter_done"
              label="Surat Cinta Done"
              required={deal.include_love_letter}
            />
            <h5>Catatan Deal:</h5>
            <p>{deal.note}</p>
            {/* Render per-product subforms */}
            <FieldArray
              name="cart_item_updates"
              render={ (arrayHelpers) => (
                <>
                  {formikBag.values.cart_item_updates?.length > 0 && (
                    <div className="mt-3">
                      {formikBag.values.cart_item_updates.map((item, index) => {
                        // const product = dataSelected.find(p => p.id === item.product_id)
                        // look up the full option object from Formik's product_ids
                        const cart_item = deal.cart.cart_items.find(o => o.id === item.id)
                        const product = cart_item?.product
                        return (
                          <div key={item.id} className="border rounded p-3 mb-3">
                            <h5>
                              {product ? `${product.id}. ${product.sku} - ${product.name}` : `Product #${index}`}
                            </h5>

                            <div className="mb-2">
                              <strong>Product Authentication Status:</strong> {productAuthenticationSummary(product).status}
                              {productAuthenticationSummary(product).link ? (
                                <span> — <a href={productAuthenticationSummary(product).link} target="_blank" rel="noopener noreferrer">Open cert/link</a></span>
                              ) : null}
                            </div>

                            <ToggleField
                              type="checkbox"
                              name={`cart_item_updates.${index}.authenticity_check_done`}
                              label="Authenticity Check Done"
                              required={cart_item.include_authenticity_check}
                              formText={`Authenticator: ${[cart_item.authenticator, cart_item.authenticity_check_note].filter(s => !!s).join(" - ")}`}
                            />

                            <h5>Catatan Item:</h5>
                            <p>{cart_item.note}</p>
                            <ToggleField
                              type="checkbox"
                              name={`cart_item_updates.${index}.note_done`}
                              label="Catatan Lain Done"
                            />
                          </div>
                        )
                      })}
                    </div>
                  )}
                </>
              )}
            />

            <hr/>

            <ToggleField
              type='checkbox'
              name='ready_to_ship'
              label='Siap Dikirim'  
            />

            <br />
            <Button
              color='primary'
              disabled={ formikBag.isSubmitting }
              onClick={async () => {
                const errors = await formikBag.validateForm()
                if (Object.keys(errors).length > 0) {
                  alert(`Please fix validation errors before submitting!\n${JSON.stringify(errors, null, 2)}`)
                } else {
                  formikBag.submitForm()
                }
              }}
            >
              Update
            </Button>
          </Form>
        )
      }
    </Formik>
  )
}

UpdatePackingForm.propTypes = propTypes

export default UpdatePackingForm
